import User from "../../../apis/User";
import Users from "../../../apis/Users";
import router from "../../../router";

const state = {
    users: [],
    userError: ""
};

const getters = {};

const actions = {
    getAllUsers({ commit }) {
        return new Promise((resolve, reject) => {
            Users.index()
                .then((response) => {
                    resolve(response.data.data[0]);
                    commit("GET_ALL_USERS", response.data.data[0])
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("GET_ALL_USERS", []);
                        commit("DETECT_USER_ERROR", error.response);
                    }
                })
        });
    },
    getUser({ commit }, id) {
        return new Promise((resolve, reject) => {
            Users.show(id)
                .then((response) => {
                    resolve(response.data.data);
                    commit("GET_USER", id);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_USER_ERROR", error.response);
                    }
                })
        })
    },
    updateUser({ commit }, { id, obj }) {
        return new Promise((resolve, reject) => {
            Users.update(id, obj)
                .then((response) => {
                    resolve(response.data.data[0]);
                    commit("UPDATE_USER", response.data.data[0]);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_USER_ERROR", error.response);
                    }
                })
        })
    }
};

const mutations = {
    GET_ALL_USERS(state, response) {
        state.users = response;
    },
    GET_USER(state, id) {

    },
    UPDATE_USER(state, obj) {
        let objIndexToUpdate = state.users.findIndex(el => el.id === obj.id);
        state.users[objIndexToUpdate] = obj;
    },
    DETECT_USER_ERROR(state, error) {
        setTimeout(() => {
            state.userError = "";
        }, 1000)

        if (error.status == 401 || error.status == 419) {
            User.logout().then(() => {
                localStorage.removeItem("auth");
                router.push({ name: "Login", path: router.currentRoute.path });
            })
        } else if (error.data.message !== undefined) {
            state.userError = error.data.message;
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}